import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router";
import './index.css';
import { Page } from './components/Page';
import { ContextLayout } from './services/dataContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ContextLayout>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Page id="language" />} />
          <Route path="/language" element={<Page id="language" />} />
          <Route path="/framework" element={<Page id="framework" />} />
          <Route path="/libraries" element={<Page id="libraries" />} />
          <Route path="/markup-styling" element={<Page id="markup-styling" />} />
          <Route path="/testing" element={<Page id="testing" />} />
          <Route path="/design" element={<Page id="design" />} />
          <Route path="/dev-env" element={<Page id="dev-env" />} />
          <Route path="/cloud-env" element={<Page id="cloud-env" />} />
          <Route path="/project-process" element={<Page id="project-process" />} />
          <Route path="/tech-process" element={<Page id="tech-process" />} />
          <Route path="/contribution" element={<Page id="contribution" />} />
          <Route path="/gen-ai" element={<Page id="gen-ai" name="Generative AI" />} />
        </Routes>
      </BrowserRouter>
    </ContextLayout>

  </React.StrictMode>
);

